/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Sync_Changes_Status_ErrorInputs */

const en_sync_changes_status_error = /** @type {(inputs: Sync_Changes_Status_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.error}`)
};

const fr_sync_changes_status_error = /** @type {(inputs: Sync_Changes_Status_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur : ${i?.error}`)
};

const de_sync_changes_status_error = /** @type {(inputs: Sync_Changes_Status_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler: ${i?.error}`)
};

const it_sync_changes_status_error = /** @type {(inputs: Sync_Changes_Status_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore: ${i?.error}`)
};

const ru_sync_changes_status_error = /** @type {(inputs: Sync_Changes_Status_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка: ${i?.error}`)
};

const es_sync_changes_status_error = /** @type {(inputs: Sync_Changes_Status_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.error}`)
};

const zh_cn2_sync_changes_status_error = /** @type {(inputs: Sync_Changes_Status_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`错误：${i?.error}`)
};

const ja_sync_changes_status_error = /** @type {(inputs: Sync_Changes_Status_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`エラー: ${i?.error}`)
};

const hi_sync_changes_status_error = /** @type {(inputs: Sync_Changes_Status_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`त्रुटि: ${i?.error}`)
};

const pt_pt2_sync_changes_status_error = /** @type {(inputs: Sync_Changes_Status_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error: {error}" |
*
* @param {Sync_Changes_Status_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_status_error = /** @type {((inputs: Sync_Changes_Status_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Status_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sync_changes_status_error(inputs)
	if (locale === "de") return de_sync_changes_status_error(inputs)
	if (locale === "it") return it_sync_changes_status_error(inputs)
	if (locale === "ru") return ru_sync_changes_status_error(inputs)
	if (locale === "es") return es_sync_changes_status_error(inputs)
	if (locale === "zh-CN") return zh_cn2_sync_changes_status_error(inputs)
	if (locale === "ja") return ja_sync_changes_status_error(inputs)
	if (locale === "hi") return hi_sync_changes_status_error(inputs)
	if (locale === "pt-PT") return pt_pt2_sync_changes_status_error(inputs)
	return en_sync_changes_status_error(inputs)
});